/* global dataLayer */
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useForm } from 'react-hook-form';
import { useStateMachine } from 'little-state-machine';
import axios from 'axios';
import _ from 'lodash';
import StepSummary from 'Components/StepSummary';
import getPaymentMethod from 'utils/getPaymentMethod';
import s from './Summary.module.scss';

// defaultState is only used by storybook
const Summary = ({ formNamespace, texts, campaignActivityNumber, defaultState = {} }) => {
    const { state } = useStateMachine();

    const currState = _.get(state, formNamespace, defaultState);

    const [loading, setLoading] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const { steg1, steg2, steg3 } = currState;
    const {
        register,
        formState,
        setValue,
        trigger,
        handleSubmit,
    } = useForm({
        mode: 'onChange',
        defaultValues: currState,
    });
    const { errors, isValid } = formState;

    const onSubmit = () => {
        setLoading(true);
        const formData = currState;
        const gift = JSON.parse(formData.gift);

        const postBody = {
            productId: gift.ID,
            companyName: formData.companyName,
            organizationNumber: formData.orgNumber,
            address: formData?.address,
            address2: formData?.address2,
            city: formData?.city,
            country: formData?.country?.value,
            email: formData.email,
            payment: formData.payment,
            phone: formData.phone,
            postalCode: formData?.postalCode,
            reference: formData.reference,
            fee: formData.freeAmount,
            campaignActivityNumber,
        };

        axios
            .post('/wp-json/gift/v1/company/', postBody, {
                validateStatus: function (status) {
                    return status < 500; // Resolve only if the status code is less than 500
                },
            })
            .then((response) => {
                return response.data;
            })
            .then((data) => {
                if (data?.result === 'success') {

                    dataLayer.push({
                        event: 'checkoutSteps',
                        eventCategory: 'företagsgåva',
                        eventAction: 'till betalning',
                    });

                    window.location.href = data.redirect;
                } else {
                    setErrorMessage(data.error);
                }
                setLoading(false);
            });
    };

    useEffect(() => {
        register('steg1');
        register('steg2');
        register('steg3');
        setValue('steg1', steg1);
        setValue('steg2', steg2);
        setValue('steg3', steg3);
        trigger(['steg1', 'steg2', 'steg3']);
    }, [state]);

    if (!(steg1 && steg2 && steg3)) {
        return '';
    }

    const formData = currState;
    const gift = JSON.parse(formData.gift);
    const amount = parseFloat(formData.freeAmount ? formData.freeAmount : gift.price);
    const company = `${formData.companyName} ${formData.orgNumber}`;
    const city = `${formData.postalCode} ${formData.city}`;
    const paymentLabel = getPaymentMethod(formData.payment);
    const submitButtonText = formData.payment === 'cod' ? 'Skicka' : 'Till betalning';

    return (
        <StepSummary
            handleSubmit={handleSubmit(onSubmit)}
            groups={[
                {title: 'controlCompany', details: {
                    company: company,
                    streetAddress: formData?.address,
                    city: city,
                    country: formData?.country?.label,
                    email: formData.email,
                    mobile: formData.phone,
                    ...(formData?.reference && {reference: formData.reference}),
                    paymentMethod: paymentLabel,
                }},
                {title: 'payment', details: {
                    amount: `${(amount).toFixed(2)} kr`,
                    total: `${(amount).toFixed(2)} kr`,
                }},
            ]}
            HiddenFields={(
                <input
                    type="hidden"
                    name="steg1"
                    {...register('steg1', { required: true })}
                />
            )}
            gdprApprove={texts.gdprApprove}
            gdprRegister={register('gdpr', {
                required:
                    'Du måse godkänna hanteringen av personuppgifter innan du kan gå vidare.',
            })}
            errors={errors}
            disabled={!isValid}
            submitButtonText={submitButtonText}
            loading={loading}
            errorMessage={errorMessage}
        />
    );
};

Summary.propTypes = {
    formNamespace: PropTypes.string,
    texts: PropTypes.object,
    campaignActivityNumber: PropTypes.string,
    defaultState: PropTypes.object,
};

export default Summary;
